import angular from 'angular';
import usersProfile from './usersProfile';

export default angular
  .module('components.usersProfile', [])
  .component('usersProfile', usersProfile).name;
